import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c3585fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_2 = { class: "overlay" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, "Trailer Solutions", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "driver-options-container"
}
const _hoisted_9 = { class: "header" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "driver-options-container-bottom"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "driver-options-container-bottom"
}
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlreadyHaveTrailerAttached = _resolveComponent("AlreadyHaveTrailerAttached")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!
  const _component_AlertSidebar = _resolveComponent("AlertSidebar")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (
                    _ctx.displayAttachedConfirmation &&
                    !_ctx.displayLoadedConfirmation &&
                    _ctx.trailerAssociationsEnabled
                )
        ? (_openBlock(), _createBlock(_component_AlreadyHaveTrailerAttached, {
            key: 0,
            attachedTrailers: _ctx.currentAttachedTrailers,
            onOnDetach: _ctx.onDetachTrailer,
            onOnSearchForTrailers: _ctx.onSearchForTrailers
          }, null, 8, ["attachedTrailers", "onOnDetach", "onOnSearchForTrailers"]))
        : _createCommentVNode("", true),
      (_ctx.displayLoadedConfirmation && _ctx.trailerAssociationsEnabled)
        ? (_openBlock(), _createBlock(_component_DriverLoaded, {
            key: 1,
            attachedTrailerNumber: _ctx.loadedTrailerNumber,
            attachedTrailerCompany: _ctx.loadedTrailerCompany,
            onOnSearchForTrailers: _ctx.onSearchForTrailers
          }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "onOnSearchForTrailers"]))
        : _createCommentVNode("", true),
      (_ctx.hasError && !_ctx.isDetachError)
        ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
            key: 2,
            message: _ctx.error?.message
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AlertSidebar, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex flex-column message-box", { start: !_ctx.shouldShowSelectATrailer }])
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.headerText), 1),
                _createElementVNode("div", {
                  class: "message",
                  innerHTML: _ctx.messageText
                }, null, 8, _hoisted_10)
              ], 2),
              (_ctx.shouldShowSelectATrailer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_fbx_button, {
                      "button-text": "Select a Trailer",
                      theme: "primary",
                      onClick: _ctx.navigateToSelectATrailer
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_fbx_button, {
                      "button-text": "Find a Trailer Elsewhere",
                      theme: "primaryOutline",
                      class: "italic",
                      onClick: _ctx.navigateToTrailerFinder
                    }, null, 8, ["onClick"]),
                    (_ctx.trailerAssociationsEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_fbx_button, {
                            class: "italic",
                            onClick: _ctx.navigateToEnterTrailer,
                            "button-text": "Attach Trailer",
                            theme: "link"
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_fbx_button, {
                      "button-text": _ctx.findTrailerButtonText,
                      theme: "primary",
                      onClick: _ctx.navigateToTrailerFinder
                    }, null, 8, ["button-text", "onClick"]),
                    (_ctx.trailerAssociationsEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_fbx_button, {
                            class: "italic",
                            "button-text": "Attach Trailer",
                            theme: "link",
                            onClick: _ctx.navigateToEnterTrailer
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
      ])
    ])
  ]))
}